import React from 'react';
// Components
import BrandPreferencesComponent from 'components/common/BrandPreferencesComponent/BrandPreferencesComponent';

const BrandPreferences = (): JSX.Element => {
  return <BrandPreferencesComponent />;
};

export default BrandPreferences;
